export const IMAGES = {
  logo: "https://customer-assets-0z36b82j.emergentagent.net/job_12631bdc-da86-4b17-a509-8d3546f27154/artifacts/b6d8ca055e798f96_elite-imperium-digital-logo.webp",
  harbor: "https://images.unsplash.com/photo-1625433002959-fbf0d2423d95?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NzA0MTJ8MHwxfHNlYXJjaHwxfHxhbnRpZ3VhJTIwY2FyaWJiZWFuJTIwaGFyYm91ciUyMGdvbGRlbiUyMGhvdXIlMjBsdXh1cnklMjByZXNvcnQlMjBzdW5zZXR8ZW58MHx8fHwxNzkyMTgwOTYwfDA&ixlib=rb-4.1.0&q=85",
  yacht: "https://images.pexels.com/photos/16968907/pexels-photo-16968907.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  resort: "https://images.pexels.com/photos/6127358/pexels-photo-6127358.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  villaInt: "https://images.unsplash.com/photo-1709747820764-ce13895aff05?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB2aWxsYSUyMGNhcmliYmVhbiUyMHJlc29ydCUyMGhvdGVsJTIwaW50ZXJpb3IlMjBhcmNoaXRlY3R1cmFsJTIwZGVzaWdufGVufDB8fHx8MTc5MjE4MDk2MHww&ixlib=rb-4.1.0&q=85",
  villaExt: "https://images.pexels.com/photos/16010609/pexels-photo-16010609.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  dining: "https://images.pexels.com/photos/33869745/pexels-photo-33869745.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  office: "https://images.pexels.com/photos/7580644/pexels-photo-7580644.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  meeting: "https://images.pexels.com/photos/12903168/pexels-photo-12903168.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  founder: "https://customer-assets-jt897jd0.emergentagent.net/job_barbuda-premium-hub/artifacts/96cb83eb0e54f73a_WhatsApp%20Image%202026-10-16%20at%2016.18.05.jpeg",
};

export const CONTACT = {
  email: "hello@eliteimperiumdigital.com",
  phone: "+1 (268) 719-0412",
  phone_uk: "+44 7444 270 857",
  office: "Antigua & Barbuda",
  hours: "Mon – Fri, 9:00 – 17:30 AST",
  whatsapp: "https://wa.me/12687190412?text=Hello%20Elite%20Imperium%20Digital%2C%20I%27d%20like%20to%20discuss%20a%20project.",
  whatsapp_uk: "https://wa.me/447444270857?text=Hello%20Elite%20Imperium%20Digital%2C%20I%27d%20like%20to%20discuss%20a%20project.",
};

export const PACKAGES = [
  {
    id: "audit",
    name: "Digital Audit",
    tag: "Start here",
    desc: "A plain-English review of your website, search visibility and booking flow, with a prioritised fix list you can act on immediately.",
    points: ["15-page bespoke analysis", "Speed and mobile checks", "Caribbean search ranking review"],
  },
  {
    id: "starter",
    name: "Starter Website",
    tag: "Most popular",
    desc: "A fast, elegant site that turns island visitors into enquiries — launched in weeks, not months, and simple for your team to update.",
    points: ["Mobile-first design", "Loads in under 3 seconds", "Built-in enquiry and WhatsApp flows"],
  },
  {
    id: "booking",
    name: "Booking & Payments",
    tag: "Revenue engine",
    desc: "Direct bookings and international card payments on your own site — fewer commissions, more margin, guests who come back to you.",
    points: ["International cards, Apple Pay, Google Pay", "Real-time availability", "Automated confirmations"],
  },
  {
    id: "automation",
    name: "Automation & AI",
    tag: "Time back",
    desc: "Practical AI that answers guests at 2am, chases invoices and files paperwork — measured in hours saved, not buzzwords.",
    points: ["AI guest concierge", "Invoice and admin automation", "Review and follow-up flows"],
  },
  {
    id: "care",
    name: "Care Plan",
    tag: "Peace of mind",
    desc: "Hosting, security, backups and small updates handled every month, with a real person on the island who answers the phone.",
    points: ["Managed hosting and SSL", "Monthly reports in plain English", "Same-day replies"],
  },
  {
    id: "advisory",
    name: "Strategic Advisory",
    tag: "On call",
    desc: "A senior technology partner in the room for board decisions, vendor negotiations and regional expansion plans.",
    points: ["Quarterly strategy sessions", "Vendor and platform guidance", "Regional delivery network"],
  },
];

export const SECTORS = ["Luxury Resorts", "Private Villas", "Yacht Charters", "Fine Dining", "Financial Services", "Dockyard Marinas", "Tour Operators", "Boutique Hotels"];

export const TESTIMONIALS = [
  {
    quote: "They speak plainly, deliver on the date they promise, and the site they built pays for itself every single week.",
    name: "General Manager",
    org: "Boutique Resort, St. John's",
  },
  {
    quote: "Our guests get answers at 2am from London. We wake up to confirmed bookings instead of missed calls.",
    name: "Owner",
    org: "Private Villa, Barbuda",
  },
  {
    quote: "One contact for everything — website, payments, even the card machine questions. It feels like having a technology director on staff.",
    name: "Managing Partner",
    org: "Financial Services Firm, Antigua",
  },
];

export const FAQS = [
  {
    q: "How quickly can we launch?",
    a: "A starter website typically launches in three to five weeks from our first session. Booking and payments builds run six to ten weeks depending on integrations. We give you a firm date in writing before any work begins — and we keep it.",
  },
  {
    q: "Do you only work with tourism businesses?",
    a: "Tourism and hospitality are our heartland, but we also serve professional and financial services firms, and regional companies that need a trusted delivery partner on the ground in Antigua and Barbuda.",
  },
  {
    q: "Can you take over our existing website?",
    a: "Usually, yes. The free digital audit tells us exactly what you have, what is worth keeping and what should be rebuilt. You get the findings either way — there is no obligation to continue with us.",
  },
  {
    q: "How do payments work for Caribbean businesses?",
    a: "We set up international card processing with Apple Pay and Google Pay, settle in USD, and handle the compliance details. Your guests pay like they would anywhere in the world; you keep more of every booking.",
  },
  {
    q: "What does the Care Plan cover?",
    a: "Managed hosting, SSL, security updates, daily backups, small content changes and a monthly plain-English report. If something breaks at 9pm before a charter show, you call us — not a ticket queue.",
  },
];

export const PACKAGE_DETAILS = {
  audit: {
    timeline: "One week from your completed form to your finished report.",
    scope: [
      "Full website and mobile speed review on real connections",
      "Caribbean and international search visibility check",
      "Booking and payment readiness assessment",
      "Software and admin workflow review",
      "Security, backups and data-protection review (Data Protection Act 2013)",
      "AI opportunity assessment — where it helps, where it shouldn't be used",
    ],
    ideal: "Owners who suspect their digital presence is quietly costing them bookings, and want evidence before spending a dollar.",
    gallery: ["office", "meeting"],
  },
  starter: {
    timeline: "Three to five weeks from first session to launch.",
    scope: [
      "Design and build of a fast, mobile-first website",
      "Copy polished into plain English that sells",
      "Enquiry and WhatsApp flows built in from day one",
      "Search setup and Google Business Profile check",
      "Training so your team can update content themselves",
      "First month of the Care Plan included",
    ],
    ideal: "Villas, restaurants, charters and firms whose current site undersells them — or who have no site at all.",
    gallery: ["harbor", "villaInt"],
  },
  booking: {
    timeline: "Six to ten weeks, depending on integrations.",
    scope: [
      "A direct booking engine on your own website",
      "International cards, Apple Pay and Google Pay",
      "Real-time availability with instant confirmation",
      "Automated pre-arrival and post-stay review emails",
      "Rates and promotions your team controls directly",
      "Care Plan included for the first quarter",
    ],
    ideal: "Hotels, resorts and charter companies tired of handing a fifth of every booking to the OTAs.",
    gallery: ["resort", "dining"],
  },
  automation: {
    timeline: "Four to eight weeks, delivered in measured stages.",
    scope: [
      "AI concierge trained on your own property guidebook",
      "Invoice chasing and document handling automation",
      "Review collection and guest follow-up flows",
      "Reporting on hours saved, in plain numbers",
      "Staff training so the tools actually get used",
      "Optional WhatsApp and voice-note handling",
    ],
    ideal: "Teams drowning in repeat questions, paperwork and manual admin.",
    gallery: ["villaExt", "meeting"],
  },
  care: {
    timeline: "Starts within one week; runs monthly, cancel anytime.",
    scope: [
      "Managed hosting, SSL and security updates",
      "Daily backups with restore testing",
      "Small content changes every month included",
      "A monthly report in plain English",
      "Same-day responses — one phone number, one contact",
      "Quarterly performance review",
    ],
    ideal: "Owners who want their digital presence handled properly without hiring anyone.",
    gallery: ["office", "harbor"],
  },
  advisory: {
    timeline: "Quarterly sessions, on call between them.",
    scope: [
      "Quarterly strategy sessions with the founder",
      "Vendor and platform negotiations on your side of the table",
      "Technology roadmaps for regional expansion",
      "Board-ready briefings in plain English",
      "Priority access to the delivery team",
      "Annual digital health review",
    ],
    ideal: "Groups and firms making technology decisions with real money attached.",
    gallery: ["meeting", "yacht"],
  },
};
